import { Box, Divider, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import styles from "./InsiderBenefits.module.css";
import insiderIllustration from "assets/illustration-insider.png";
import checkIcon from "assets/icn-green-chck.png";

const InsiderBenefits: React.FC = () => {
  return (
    <Box
      data-qatag="insiderBenefitsContainer"
      className={styles.insiderBenefitsContainer}
    >
      <Box
        data-qatag="insiderBenefitsContent"
        className={styles.insiderBenefitsContent}
      >
        <Box
          data-qatag="insiderBenefitsElements"
          className={styles.insiderBenefitsElements}
        >
          <img
            data-qatag="insiderbenefits.image.normal"
            className={styles.insiderIllustration}
            src={insiderIllustration}
            alt="insider-benefits"
          />

          <Typography
            variant="h5"
            style={{ color: "#007DBA" }}
            className={styles.titleInsiderBenefits}
          >
            <FormattedMessage
              defaultMessage="What You Get {br} For Your Entire Family"
              values={{
                br: <br />,
              }}
            />
          </Typography>
          <Box
            data-qatag="insiderbenefits.tabletcontainer"
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              data-qatag="insiderbenefits.image.tablet"
              className={styles.insiderIllustration_tablet}
              src={insiderIllustration}
              alt="insider-benefits"
            />
            <Box data-qatag="insiderbenefits.entrycontainer">
              <Box
                data-qatag="insiderbenefits.driver.entry"
                display="flex"
                alignItems="center"
                mt={2}
              >
                <img
                  data-qatag="insiderbenefits.driver.entry.image"
                  className={styles.checkIcon}
                  src={checkIcon}
                  alt="insider-benefits"
                />
                <Typography
                  data-qatag="insiderbenefits.driver.entry.text"
                  variant="body1"
                  style={{ fontSize: "18px" }}
                >
                  <FormattedMessage defaultMessage="Device Driver Updates &amp; Monitoring" />
                </Typography>
              </Box>

              <Box
                data-qatag="insiderbenefits.privacy.entry"
                display="flex"
                alignItems="center"
                mt={2}
              >
                <img
                  data-qatag="insiderbenefits.privacy.entry.image"
                  className={styles.checkIcon}
                  src={checkIcon}
                  alt="insider-benefits"
                />
                <Typography
                  data-qatag="insiderbenefits.privacy.entry.text"
                  variant="body1"
                  style={{ fontSize: "18px" }}
                >
                  <FormattedMessage defaultMessage="Ad Blocking &amp; Tracker Privacy" />
                </Typography>
              </Box>

              <Box
                data-qatag="insiderbenefits.deceptiveapps.entry"
                display="flex"
                alignItems="center"
                mt={2}
              >
                <img
                  data-qatag="insiderbenefits.deceptiveapps.entry.image"
                  className={styles.checkIcon}
                  src={checkIcon}
                  alt="insider-benefits"
                />
                <Typography
                  data-qatag="insiderbenefits.deceptiveapps.entry.text"
                  variant="body1"
                  style={{ fontSize: "18px" }}
                >
                  <FormattedMessage defaultMessage="Deceptive App Protection" />
                </Typography>
              </Box>

              <Box
                data-qatag="insiderbenefits.malware.entry"
                display="flex"
                alignItems="center"
                mt={2}
              >
                <img
                  data-qatag="insiderbenefits.malware.entry.image"
                  className={styles.checkIcon}
                  src={checkIcon}
                  alt="insider-benefits"
                />
                <Typography
                  data-qatag="insiderbenefits.malware.entry.text"
                  variant="body1"
                  style={{ fontSize: "18px" }}
                >
                  <FormattedMessage defaultMessage="Malware Domain Protection" />
                </Typography>
              </Box>

              <Box
                data-qatag="insiderbenefits.optimizations.entry"
                display="flex"
                alignItems="center"
                mt={2}
              >
                <img
                  data-qatag="insiderbenefits.optimizations.entry.image"
                  className={styles.checkIcon}
                  src={checkIcon}
                  alt="insider-benefits"
                />
                <Typography
                  data-qatag="insiderbenefits.optimizations.entry.text"
                  variant="body1"
                  style={{ fontSize: "18px" }}
                >
                  <FormattedMessage defaultMessage="App Performance Optimizations" />
                </Typography>
              </Box>

              <Box
                data-qatag="insiderbenefits.free.entry"
                display="flex"
                alignItems="center"
                mt={2}
              >
                <img
                  data-qatag="insiderbenefits.free.entry.image"
                  className={styles.checkIcon}
                  src={checkIcon}
                  alt="insider-benefits"
                />
                <Typography
                  data-qatag="insiderbenefits.free.entry.text"
                  variant="body1"
                  style={{ fontSize: "18px" }}
                >
                  <FormattedMessage defaultMessage="30 days Free!" />
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      {/* Divider */}
      <Box data-qatag="divider" className={styles.divider}>
        <Divider data-qatag="dividerItem" />
      </Box>
    </Box>
  );
};

export default InsiderBenefits;
